module.exports = __webpack_public_path__ + "static/media/28-4.d6fc8e59.mp3";